import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import Styles from "./formTextField.lit.scss";
import {FormInputElement} from "./formInputElement";
import {InputElementType} from "../validations/validations";
import {spreadAttributes} from "../../../common/directives/spreadAttributes";
import type {Maybe} from "../../../bootstrap/common/types";

@customElement("eop-form-text-field")
export class EopFormTextField extends FormInputElement<string> {

    public static readonly styles = Styles;

    @property({attribute: "label"})
    public label: string;
    @query("input")
    private input: HTMLInputElement;

    public constructor() {
        super("");
        this.type = InputElementType.TEXT;
    }

    public render(): TemplateResult {
        return html`
            <div class="input-element ${this.basicClassMap()}">
                <input
                        id=${this.formUUId}
                        name=${this.getFullId()}
                        .value=${this.value}
                        ?filled=${this.value}
                        @change=${this.change}
                        @input=${this.onInput}
                        type=${this.type}
                        ?required=${this.required}
                        ${spreadAttributes(this.customAttributes)}
                >
                <label for=${this.formUUId} @click=${this.preventLabelDefaultAction}>
                    <span class="label-text">${this.label}</span>
                    ${this.labelSuffix()}
                </label>
                ${this.renderValidationIcon()}
            </div>
            ${(this.renderValidationMessages())}
        `;
    }

    public focusInput(): void {
        this.input.focus();
    }

    protected preset(): Maybe<string> {
        return this.getAttribute("preset") ?? undefined;
    }

    private change(event: Event): void {
        this.updateValue((event.target as HTMLInputElement).value);
    }

    private onInput(event: Event): void {
        if (this.isValidatable) {
            this.updateValidState((event.target as HTMLInputElement).value);
        }
    }
}